import { render, staticRenderFns } from "./ClearCartButton.vue?vue&type=template&id=d3f498a8&scoped=true&"
var script = {}
import style0 from "./ClearCartButton.vue?vue&type=style&index=0&id=d3f498a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f498a8",
  null
  
)

export default component.exports